<mat-drawer-container class="container" autosize>
  <div class="top-line">
    <button mat-flat-button (click)="isRequestDrawerOpen = true">Request Product</button>
    <div *ngIf="showRecents" class="recent-buttons" [class.hidden]="isDrawerOpen || isRequestDrawerOpen">
      <button [disabled]="!recentMode" mat-icon-button color="accent" matTooltip="Search products" (click)="recentMode = false">
        <mat-icon>search</mat-icon>
      </button>
      <button [disabled]="recentMode" mat-icon-button color="accent" matTooltip="View recent products" (click)="recentMode = true">
        <mat-icon>history</mat-icon>
      </button>
    </div>
  </div>
  <mat-drawer #productDetails class="sidenav" mode="over" position="end" [opened]="isDrawerOpen" (closed)="onProductDetailsClose()">

    <ng-container *ngIf="!productConfirmed">

        <div *ngIf="selectedProducts.length <= 1" #modelContainer class="w-100 p-20" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px" [class.show-previous]="showPrevious">
          <h3>Product Preview</h3>

          <div class="image-preview">
            <model-viewer [fxShow]="url" id="glb"
              [style.height.px]="productWidth" [style.width.px]="productWidth"
              shadow-intensity="1" camera-controls touch-action="pan-y"
              [src]="url"
              [poster]="posterUrl"
              data-js-focus-visible=""
              ar-status="not-presenting"
              min-camera-orbit="auto auto 10%" max-camera-orbit="auto auto 100%"
              min-field-of-view="45deg" max-field-of-view="90deg"
              camera-orbit="225deg 55deg auto"
              environment-image="https://cdn.situsystems.com/products/small_empty_room_3_4k.jpg"
              environment-image-intensity="0.35"
              alt="Model preview"
              tone-mapping="aces">
            </model-viewer>

            <ng-container *ngIf="!url">
              <div fxLayout="column" fxLayoutAlign="center center">
                <img src="/assets/images/no-image-icon.svg" class="no-image-preview">
              </div>
            </ng-container>
          </div>

          <img class="company-logo" *ngIf="getCompanyLogo(selectedProducts[0]?.companyId)" [src]="getCompanyLogo(selectedProducts[0]?.companyId)" alt="">
          <small *ngIf="!getCompanyLogo(selectedProducts[0]?.companyId)">{{ getCompanyName(selectedProducts[0]?.companyId ?? selectedProducts[0]?.supplierId) }}</small>
          <div [style.color]="getProductTypeColor(selectedProducts?.productTypeId)">{{ selectedProducts[0]?.name }}</div>
          <button mat-flat-button color="accent" (click)="selectProduct()">Select Product</button>

          <ng-container *ngIf="showPrevious">
            <div fxLayout="row" fxLayoutAlign="center center" class="previous-product">
              <mat-icon>arrow_downward</mat-icon>
              <small>Replacing...</small>
            </div>
            <img [src]="previousUrl" class="image-preview previous-product">
          </ng-container>
        </div>

      <div *ngIf="selectedProducts.length !== 1">
        <div class="w-100 p-20" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
          <h3>Selected Products</h3>
        </div>

        <div class="p-20">
          <div *ngFor="let item of selectedProducts">
            <b>{{ getCompanyName(item.companyId) }}</b> - {{ item.name }}
          </div>
        </div>

        <div class="w-100 p-20" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
          <button mat-flat-button color="accent" (click)="selectProduct()">Confirm Product Selection</button>
        </div>

      </div>

    </ng-container>

    <ng-container *ngIf="productConfirmed">

      <div *ngIf="!selectedType" class="w-100 p-20" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px">
        <h3>Select Type</h3>

        <mat-chip-list fxLayout="row wrap" fxLayoutAlign="center center">
          <mat-chip *ngFor="let type of themeLineItemTypes" (click)="selectType(type)">
            {{ type?.name }}
          </mat-chip>
        </mat-chip-list>
      </div>

      <div *ngIf="selectedType" class="w-100 p-20" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px">
        <h3>Select Tags</h3>

        <mat-chip-list *ngIf="selectedTags.length !== 0" class="w-100" fxLayout="row wrap" fxLayoutAlign="start start">
          <mat-chip class="green-chip" *ngFor="let tag of selectedTags" class="green-chip">
            {{ tag }}
            <button matChipRemove (click)="removeTag(tag)">
              <mat-icon style="color: #000">clear</mat-icon>
            </button>
          </mat-chip>
        </mat-chip-list>

        <button mat-flat-button color="primary" matTooltip="Select Tags" (click)="confirmTags()">
          {{ selectedTags?.length === 0 ? 'Continue With No Tags' : 'Select Tags' }}
        </button>

        <mat-form-field class="accent">
          <mat-label>Filter Tags</mat-label>
          <input matInput type="text" name="searchTerm"
              [(ngModel)]="searchTerm"
              (ngModelChange)="emitChange()">
          <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''; filterTags()">
              <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <mat-chip-list class="w-100" fxLayout="row wrap" fxLayoutAlign="start start">
          <mat-chip *ngFor="let tag of filteredTags" (click)="selectTag(tag)" [innerHtml]="tag | encodeHtml | highlight: searchTerm">
          </mat-chip>
        </mat-chip-list>

        <div *ngIf="remainingFilteredTags.length > 0" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px" class="w-100">
          <button mat-button (click)="showRemainingTags = !showRemainingTags">
            <mat-icon *ngIf="!showRemainingTags">arrow_right</mat-icon>
            <mat-icon *ngIf="showRemainingTags">arrow_drop_down</mat-icon>
            Show All Tags
          </button>

          <mat-chip-list *ngIf="showRemainingTags" class="w-100" fxLayout="row wrap" fxLayoutAlign="start start">
            <mat-chip *ngFor="let tag of remainingFilteredTags" (click)="selectTag(tag)" [innerHtml]="tag | encodeHtml | highlight: searchTerm">
            </mat-chip>
          </mat-chip-list>
        </div>

        <div *ngIf="loadingTags">
          Loading Tags...
        </div>
      </div>

    </ng-container>

  </mat-drawer>

  <mat-drawer #productRequest class="sidenav-request" mode="over" position="start" [opened]="isRequestDrawerOpen" (closed)="onRequestClose()">
    <div fxFlex fxLayout="column" fxLayoutAlign="center center">
      <h2>Request Product</h2>
      <div class="w-100" fxFlex="100" fxLayout="row wrap" fxLayoutAlign="center start">
        <mat-chip-list fxFlex="100" fxLayout="column" fxLayoutAlign="start center">
          <mat-chip *ngFor="let productType of allProductTypes"
          [class.green-chip]="productType.name === requestedProductType?.name"
          (click)="productType?.name === requestedProductType?.name ? '' : requestedProductType = productType">
            <span>{{ productType?.name }}</span>
            <button matChipRemove color="primary" *ngIf="productType.name === requestedProductType?.name" (click)="requestedProductType = undefined">
              <mat-icon color="basic">clear</mat-icon>
            </button>
          </mat-chip>
        </mat-chip-list>
        <div class="m-t-40" fxFlex="100" *ngIf="requestedProductType">
          <div *ngIf="requestedCompany" fxLayout="column" fxLayoutAlign="start center">
            <img *ngIf="requestedCompany?.logoUrl" class="company-logo" [src]="requestedCompany?.logoUrl">
            <div fxLayout="row" fxLayoutAlign="center center">
              <span>{{ requestedCompany?.name }}</span>
              <button style="transform: scale(0.7);" mat-icon-button color="basic" (click)="clearCompany()">
                <mat-icon>clear</mat-icon>
              </button>
            </div>
          </div>
          <div *ngIf="requestedSupplier" fxLayout="row" fxLayoutAlign="center center">
            <span>{{ requestedSupplier }}</span>
            <button style="transform: scale(0.7);" mat-icon-button color="basic" (click)="clearCompany()">
              <mat-icon>clear</mat-icon>
            </button>
          </div>
          <form>
            <div *ngIf="!requestingSupplier && !requestedCompany" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
              <mat-form-field style="max-width: 540px;">
                <input matInput type="text" placeholder="Select Supplier" matInput [formControl]="companyControl" [matAutocomplete]="companyAuto">
                <mat-autocomplete #companyAuto="matAutocomplete" (optionSelected)="onCompanySelected($event)">
                  <mat-option *ngFor="let company of filteredCompanies | async" [value]="company">
                      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                          <img class="company-logo-dropdown" *ngIf="company?.logoUrl" [src]="company.logoUrl" [matTooltip]="company?.name" />
                          <span [innerHtml]="company.name | encodeHtml | highlight: companyControl.value"></span>
                      </div>
                  </mat-option>
                </mat-autocomplete>
                <button mat-button *ngIf="!requestedCompany" matSuffix mat-icon-button matTooltip="Request Supplier" (click)="requestingSupplier = true">
                  <mat-icon>add</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div *ngIf="requestingSupplier && !requestedSupplier" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
              <mat-form-field style="max-width: 540px;">
                <input matInput type="text" placeholder="Enter Supplier" matInput [formControl]="supplierControl">
                <button mat-button *ngIf="!requestedCompany" matSuffix mat-icon-button matTooltip="View Suppliers" (click)="requestingSupplier = false">
                  <mat-icon>list</mat-icon>
                </button>
              </mat-form-field>
              <button *ngIf="!requestedCompany" mat-button mat-flat-button color="primary" matTooltip="Request Supplier" (click)="requestSupplier()">
                Request Supplier
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </mat-drawer>

  <div [class.hidden]="showRecents && recentMode" class="sidenav-content">
    <product-catalog-list
      [templateNameFilter]="data.templateNameFilter"
      [relatedTagsOrder]="data.relatedTagsOrder"
      [tagGroupsFilter]="data.tagGroupsFilter"
      (onProductSelected)="onProductSelected($event)"
      [multiSelect]="data.multiSelect"
      [allowRequestedProducts]="data.allowRequestedProducts">
    </product-catalog-list>
  </div>
  <div *ngIf="showRecents" [class.hidden]="!recentMode" class="sidenav-content">
    <mat-card class="w-100">
      <mat-card-content>
        <div *ngIf="recentProducts && filteredRecentProducts && recentProducts.length != filteredRecentProducts.length" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
          <div *ngIf="filteringBy != ''"><b>Filtering by:</b> {{ filteringBy }}</div>
          <button mat-flat-button color="accent" (click)="clearRecentsFilters()"> Clear Filters </button>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="center center">
          <ng-container *ngFor="let item of filteredRecentProducts">
              <thumb-product-card
                  [item]="item"
                  [isCatalog]="false"
                  [canExpandImage]="false"
                  (click)="onRecentSelected(item); $event.stopPropagation()"
                  [situView]="SituViewUrl"
                  [productTypeColor]="getProductTypeColor(item.productTypeId)"
                  [productTypeName]="getProductTypeName(item.productTypeId)"
                  [companyName]="getCompanyName(item.companyId)"
                  [companyLogo]="getCompanyLogo(item.companyId)"
                  (filterCompanyId)="filterRecentsByCompany($event)"
                  (filterProductTypeId)="filterRecentsByProductType($event)">
              </thumb-product-card>
          </ng-container>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</mat-drawer-container>
